import { render, staticRenderFns } from "./UsuarioList.vue?vue&type=template&id=628530b0&scoped=true&"
import script from "./UsuarioList.vue?vue&type=script&lang=js&"
export * from "./UsuarioList.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioList.vue?vue&type=style&index=0&id=628530b0&lang=scss&scoped=true&"
import style1 from "./UsuarioList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628530b0",
  null
  
)

export default component.exports